import React, { Component } from 'react';

import ReactToPrint from 'react-to-print';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import CallIcon from '@material-ui/icons/Call';
import PrintIcon from '@material-ui/icons/Print';

const styles = theme => ({
  receipt: {
    marginLeft: 12,
  },
  root: {
    marginBottom: 12,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  stepper: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});

function getSteps() {
  return ['Preparing Order', 'Out For Delivery', 'Delivered'];
}

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
    return 'Start Preparing Order';
    case 1:
    return 'Mark Out for Delivery';
    case 2:
    return 'Mark as Delivered';
    case 3:
    return 'Move to Archives';
    default:
    return 'Move to Archives';
  }
}


class ComponentToPrint extends Component {
  render() {
    const { order } = this.props
    return (
      <div style={{fontSize: 10, margin: 12}}>
      <p style={{fontSize: 10, marginTop: 12, padding: 0, textAlign: "center" }}>
      <b>Sanvika Foodzo</b>
      <br/>
      {new Intl.DateTimeFormat('en-IN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(order.timestamp) }
      <br/>
      {order.name}
      <br/>
      {order.phoneNumber}
      <br/>
      {order.address.replaceAll(';', '\n')}
      </p>
      
      <table style={{fontSize: 10, marginTop: 12, padding: 0, width: 200}}>
      <thead>
      <th>Item</th>
      <th>Q</th>
      <th>$$</th>
      </thead>
      <tbody>
      {order.cart.map((item) => (
        <tr>
        <td>{item.name}</td>
        <td>{item.quantity}</td>
        <td>{item.total}</td>
        </tr>
        ))}
        <tr>
        <td>-------------------</td>
        <td>-----</td>
        <td>-----</td>
        </tr>
        <tr>
        <td></td>
        <td>taxes</td>
        <td>{order.taxes}</td>
        </tr>
        <tr>
        <td></td>
        <td>delivery</td>
        <td>{order.deliveryCharge}</td>
        </tr>
        <tr>
        <td></td>
        <td>packing</td>
        <td>{order.packingCharge}</td>
        </tr>
        <tr>
        <td></td>
        <td></td>
        <td>-----</td>
        </tr>
        <tr>
        <td></td>
        <td>discount</td>
        <td>{order.discount}</td>
        </tr>
        <tr>
        <td></td>
        <td></td>
        <td>-----</td>
        </tr>
        <tr>
        <td></td>
        <td>total</td>
        <td>{order.amount}</td>
        </tr>
        </tbody>
        </table>
        
        
        <p style={{fontSize: 10, marginTop: 12, padding: 0, textAlign: "center" }}>
        {(order.payment === "COD") ?
        <b>COLLECT CASH ON DELIVERY!</b>
        :
        <b>PAYMENT COMPLETED</b>
      }
      <br/>
      <b>Amount: ₹{order.amount}</b>
      <br/>
      <br/>
      Thanks for your purchase! 
      <br/>
      sanvikafoodzo.com
      </p>
      </div>
      );
    }
  }
  
  
  class KotToPrint extends Component {

    constructor(props) {
      super(props)
      
      this.state = {
        total: 0
      }
    }
    
    componentDidMount() {
      var total = 0;
      for (var i=0; i<this.props.order.cart.length; i++) {
          total += parseInt(this.props.order.cart[i].quantity);
      }
      this.setState({
        total: total
      })
    }

    render() {
      const { order } = this.props
      return (
        <div style={{fontSize: 10, margin: 12}}>
        <p style={{fontSize: 10, marginTop: 12, padding: 0, textAlign: "center" }}>
        <b>Order{order.order_id.toUpperCase()}</b>
        <br/>
        {new Intl.DateTimeFormat('en-IN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(order.timestamp) }
        </p>
        <table style={{fontSize: 10, marginTop: 12, padding: 0, width: 200}}>
        <thead>
        <th>Item</th>
        <th>Qty</th>
        </thead>
        <tbody>
        <tr>
        <td>---------</td>
        <td>---------</td>
        </tr>
        {order.cart.map((item) => (
          <tr>
          <td>{item.name}</td>
          <td>{item.quantity}</td>
          </tr>
          ))}
          <tr>
          <td>---------</td>
          <td>---------</td>
          </tr>
          <tr>
          <td>TOTAL</td>
          <td>{this.state.total}</td>
          </tr>
          </tbody>
          </table>
          <p>{order.instructions == "" ? "" : "Instructions: "} <b>{order.instructions}</b></p>
          </div>
          );
        }
      }
      
      class OrderCard extends Component {
        
        constructor(props) {
          super(props)
          
          this.state = {
            activeStep: 0
          }
        }
        
        componentDidMount() {
          this.setState({
            activeStep: this.props.order.status
          })
        }
        
        pad(num) {
          return ("0" + num).slice(-2);
        }
        
        getTimeFromDate(timestamp) {
          var date = new Date(timestamp * 1000);
          var hours = date.getHours();
          var minutes = date.getMinutes();
          var seconds = date.getSeconds();
          return this.pad(hours) + ":" + this.pad(minutes) + ":" + this.pad(seconds)
        }
        
        handleNext = () => {
          
          this.props.updateHandler(this.props.order)
          
        };
        
        render() {
          
          const steps = getSteps()
          
          const { classes, order } = this.props
          
          
          
          return (
            <Grid item xs={12} sm={6} ml={4}>
            <Card className={classes.root}>
            <CardContent>
            <Typography color="textSecondary">
            {/* {this.getTimeFromDate(order.timestamp)} */}
            {new Intl.DateTimeFormat('en-IN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(order.timestamp) }
            </Typography>
            <Typography color="textSecondary">
            {order.name}
            </Typography>
            <Typography variant="h6" component="h3">
            {order.address.replaceAll(';', '\n')}
            </Typography>
            {(order.payment === "COD") ? 
            <b style={{ color: "#1565c0" }}>Cash On Delivery</b>
            :
            <b style={{ color: "#43a047" }}>Online Payment</b>
          }
          <Typography component="h6">
          { order.instructions === "" ? <> </>: <b><span style={{ color: "#ffa500" }}>Special Instuction: </span>{order.instructions}</b> }
          </Typography>
          
          <TableContainer component={Paper} style={{ marginTop: "16px", marginBottom: "16px" }}>
          <Table size="small">{/* size="small" */}
          <TableHead>
          <TableRow>
          <TableCell><b>Item</b></TableCell>
          <TableCell align="right"><b>Quantity</b></TableCell>
          {/* <TableCell align="right"><b>Price</b></TableCell> */}
          </TableRow>
          </TableHead>
          <TableBody>
          {order.cart.map((item) => (
            <TableRow key={item.name}>
            <TableCell component="th" scope="row">
            {item.name}
            </TableCell>
            <TableCell align="right">{item.quantity}</TableCell>
            {/* <TableCell align="right">{item.price}</TableCell> */}
            </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer>
            <Typography color="textSecondary" style={{ fontSize: 10 }}>
            Total: ₹{order.total} {'-----'} Offer Applied: {order.coupon}
            </Typography>
            {(order.payment === "COD") ?
            <b style={{ color: "#d32f2f", fontSize: 10, marginTop: 0 }}>COLLECT CASH ON DELIVERY!</b>
            :
            <b style={{ color: "#43a047", fontSize: 10, marginTop: 0 }}>PAYMENT COMPLETED</b>
          }
          <Typography variant="h6" component="h3">
          <b>Amount: ₹{order.amount}</b>
          </Typography>
          
          {/* <Typography variant="body2" component="p">
          well meaning and kindly.
          <br />
          {'"a benevolent smile"'}
        </Typography> */}
        <div className={classes.stepper}>
        <Stepper activeStep={order.status} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
          <StepLabel>{label}</StepLabel>
          </Step>
          ))}
          </Stepper>
          </div>
          </CardContent>
          <CardActions>
          <a href={"tel:" + order.phoneNumber} style={{ textDecoration: 'none' }}>
          <Button variant="contained" color="secondary" startIcon={<CallIcon />}>
          Call
          </Button>
          </a> 
          <div>
          {order.status === steps.length ? (
            <Button variant="contained" onClick={this.handleNext}>
            Move to Archive
            </Button>
            ) : (
              <div>
              <div>
              <Button variant="contained" color="primary" onClick={this.handleNext}>
              {getStepContent(order.status)}
              </Button>
              </div>
              </div>
              )}
              </div>
              <div>
              <ReactToPrint
              trigger={() => {
                // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                // to the root node of the returned component as it will be overwritten.
                return <a href="#" style={{ textDecoration: 'none' }}>
                <Button variant="contained" startIcon={<PrintIcon />}>
                RECEIPT
                </Button>
                </a> 
              }}
              content={() => this.receiptComponenet}
              />
              <div style={{ display: "none" }}>
              <ComponentToPrint ref={el => (this.receiptComponenet = el)} order={order} classes={classes}/>
              </div>
              </div>
              <ReactToPrint
              trigger={() => {
                // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                // to the root node of the returned component as it will be overwritten.
                return <a href="#" style={{ textDecoration: 'none' }}>
                <Button variant="contained" startIcon={<PrintIcon />}>
                KOT
                </Button>
                </a> 
              }}
              content={() => this.kotComponent}
              />
              <div style={{ display: "none" }}>
              <KotToPrint ref={el => (this.kotComponent = el)} order={order} classes={classes}/>
              </div>
              </CardActions>
              </Card>
              </Grid >
              );
            }
            
          }
          
          export default withStyles(styles)(OrderCard)